var counter = document.querySelector(".counter");
var follow = document.querySelector(".follow")



//Set Interval
let count = 1;
setInterval( () => {
    if(count < 1000){
        count++;
    counter.innerHTML = count;
    }
}, 0.5)

//Set Timeout
setTimeout(() => {
    follow.innerHTML = "Followers on"
}, 3000)

